module.exports = __webpack_public_path__ + "static/img/METASENSE.60ce5130.svg";